export default __webpack_public_path__ + "static/media/223.36a86681.png";